import './LiveLoveLegacy.css'

const LiveLoveLegacy = () => {
  const scrollToSection = (href: string) => {
    const target = document.querySelector(href)
    if (target) {
      const offsetTop = (target as HTMLElement).offsetTop - 80
      window.scrollTo({ top: offsetTop, behavior: 'smooth' })
    }
  }

  return (
    <section id="live-love-legacy" className="welcome">
      <div className="welcome-grid">
        <div className="welcome-copy">
          <p className="welcome-kicker">Live · Love · Legacy</p>
          <h2>For the ones we love.</h2>
          <p>
            A clear place for their voice, their wishes, and the love that should not be left unsaid. Take your time.
          </p>
          <div className="welcome-cta">
            <button className="btn btn-primary" onClick={() => scrollToSection('#legacy-books')}>
              See the journals
            </button>
            <button className="btn btn-secondary" onClick={() => scrollToSection('#contact')}>
              Talk with us
            </button>
          </div>
        </div>
        <figure className="welcome-visual">
          <img
            src="/books/echo-my-legacy.jpg"
            alt="ECHO My Legacy Journal — a tree whose roots form a heart"
          />
        </figure>
      </div>
    </section>
  )
}

export default LiveLoveLegacy
